import { CustomizedFields as CFields } from 'models';
import Enums from 'utils/EnumsManager';
import { SET_DATA, SET_FETCH_STATUS } from './actionTypes';

const { Leads, Accounts, Opportunities } = Enums.ObjectTypes;

// Utils
const reduceFieldsInType = data => {
  if (_.isEmpty(data)) return [];
  return ['main', 'cstm'].reduce((accumulator, key) => {
    const obj = data[key] || {};
    if (!_.isArray(obj.data)) return accumulator;
    return [...accumulator, ...obj.data];
  }, []);
};

const reduceFields = data => {
  if (!_.isPlainObject(data) || _.isEmpty(data)) return [];

  return [Leads, Accounts, Opportunities].reduce((accumulator, type) => {
    if (_.isEmpty(data[type])) return accumulator;
    return [...accumulator, ...reduceFieldsInType(data[type])];
  }, []);
};

const initialState = {
  data: [],
  isFetched: false
};

const fields = (state = initialState, action) => {
  switch (action.type) {
    case SET_DATA:
      // create instances by type
      const instances = reduceFields(action.payload.data).map(f => {
        const {
          id,
          field_name,
          field_label,
          is_sys_auto,
          crm_data_type,
          lookup_own_field_name,
          model_type,
          is_restricted_to_me
        } = f;
        if (!CFields[crm_data_type]) {
          console.warn('No such type in customized field! Please check');
          return null;
        }
        return new CFields[crm_data_type]({
          id,
          name: field_name,
          label: field_label,
          isSystemField: !!is_sys_auto,
          lookupKey: lookup_own_field_name,
          modelType: model_type,
          type: crm_data_type,
          restriction: is_restricted_to_me
        });
      });
      return {
        ...state,
        data: instances,
        isFetched: true
      };

    case SET_FETCH_STATUS:
      return {
        ...state,
        isFetched: action.payload.isFetched
      };

    default:
      return state;
  }
};

export default fields;



// WEBPACK FOOTER //
// ./src/store/metaData/fields/reducer.js